import { ChangeEvent } from 'react';
import { Box } from '@nimbus-ds/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { FormInput } from '../common';

interface PersonalInfoSectionProps {
  firstName: string;
  lastName: string;
  ownerEmail: string;
  errors: {
    firstName?: string;
    lastName?: string;
    ownerEmail?: string;
  };
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isLoading: boolean;
}

export function PersonalInfoSection({
  firstName,
  lastName,
  ownerEmail,
  errors,
  handleChange,
  handleBlur,
  isLoading,
}: Readonly<PersonalInfoSectionProps>) {
  const t = useTranslationConfigurations(
    'domains.checkout.registrationInfo.personalInfo',
  );

  return (
    <>
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap="4">
        <FormInput
          label={t('firstName')}
          name="firstName"
          value={firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.firstName}
          isLoading={isLoading}
        />
        <FormInput
          label={t('lastName')}
          name="lastName"
          value={lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.lastName}
          isLoading={isLoading}
        />
      </Box>

      <FormInput
        label={t('ownerEmail')}
        name="ownerEmail"
        type="email"
        value={ownerEmail}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.ownerEmail}
        isLoading={isLoading}
      />
    </>
  );
}
